import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ArticleService } from '../../services/article.service';
import { AuthenticationService } from '../../services/auth/authentication.service';

@Component({
  selector: 'app-update-article',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './update-article.component.html',
  styleUrl: './update-article.component.scss',
})
export class UpdateArticleComponent implements OnInit {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private articleService: ArticleService,
    private authService: AuthenticationService,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      id: fb.control(null, Validators.required),
      name: fb.control('', Validators.required),
      unitOfMeasurement: fb.control('', Validators.required),
      price: fb.control(0.0, [Validators.required, Validators.min(0.0)]),
      active: fb.control(true, Validators.required),
    });
  }

  ngOnInit(): void {
    let articleRaw = localStorage.getItem('edit');

    if (articleRaw == null) {
      this.router.navigateByUrl('dashboard/articles');
    } else {
      localStorage.removeItem('edit');
      let article = JSON.parse(articleRaw);
      this.form.setValue(article);
      this.form.controls['active'].setValue(article.active == 1);
    }
  }

  updateArticle() {
    if (this.form.valid) {
      this.submitting = true;
      this.articleService
        .updateArticle(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.submitting = false;
            this.router.navigateByUrl('dashboard/articles');
          },
          error: (err: HttpErrorResponse) => {
            if (err.status == 401) {
              this.authService.logout();
            } else {
              this.submitting = false;
              this.error = err.error.message;
            }
          },
        });
    } else {
      this.error = 'Please fill the fields properly';
    }
  }
}
